<template>
  <div id="questionBankGoods">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>题库商品管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 商品列表卡片 -->
    <el-card class="box-card">
      <!-- 搜索表单 -->
      <el-form
        :inline="true"
        ref="searchForm"
        :model="queryMap"
        label-width="70px"
      >
        <el-form-item label="商品标题">
          <el-input
            @keyup.enter.native="searchGoods"
            @clear="searchGoods"
            clearable
            v-model="queryMap.title"
            placeholder="请输入商品标题查询"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品类型">
          <el-select
            clearable
            @clear="searchGoods"
            v-model="queryMap.type"
            placeholder="请选择商品类型"
          >
            <el-option label="单招" value="单招"></el-option>
            <el-option label="专升本" value="专升本"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品状态">
          <el-select
            clearable
            @clear="searchGoods"
            v-model="queryMap.status"
            placeholder="请选择商品状态"
          >
            <el-option label="上架" value="上架"></el-option>
            <el-option label="下架" value="下架"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品标签">
          <el-input
            clearable
            @clear="searchGoods"
            v-model="queryMap.tags"
            placeholder="请输入标签关键词查询"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序字段">
          <el-select
            v-model="queryMap.sortField"
            placeholder="请选择排序字段"
            @change="searchGoods"
          >
            <el-option label="排序权重" value="sort"></el-option>
            <el-option label="销量" value="salesCount"></el-option>
            <el-option label="创建时间" value="createdAt"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序方向">
          <el-select
            v-model="queryMap.sortOrder"
            placeholder="请选择排序方向"
            @change="searchGoods"
          >
            <el-option label="升序" value="asc"></el-option>
            <el-option label="降序" value="desc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button type="primary" @click="searchGoods" icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="openAddDialog"
            v-hasPermission="'questionBankGoods:add'"
            >添加</el-button
          >
          <el-button
            @click="downExcel"
            v-hasPermission="'questionBankGoods:export'"
            icon="el-icon-download"
            >导出</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 商品表格 -->
      <el-table
        v-loading="loading"
        :data="goodsList"
        border
        style="width: 100%"
        height="580"
      >
        <el-table-column label="ID" prop="id" width="50"></el-table-column>
        <el-table-column
          prop="title"
          label="商品标题"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="subtitle"
          label="商品副标题"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="type"
          label="商品类型"
          width="100"
        ></el-table-column>
        <el-table-column prop="status" label="商品状态" width="100">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              type="success"
              v-if="scope.row.status === '上架'"
              >上架</el-tag
            >
            <el-tag size="mini" type="danger" v-else>下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="originalPrice"
          label="原价"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="discountPrice"
          label="折扣价"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="sellingPrice"
          label="实际售价"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="salesCount"
          label="销量"
          width="80"
          sortable
        ></el-table-column>
        <el-table-column prop="totalDuration" label="有效期" width="120">
          <template slot-scope="scope">
            {{
              scope.row.totalDuration === 0
                ? "永久有效"
                : scope.row.totalDuration + "天"
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序权重"
          width="100"
          sortable
        ></el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="320">
          <template slot-scope="scope">
            <el-button
              v-hasPermission="'questionBankGoods:edit'"
              size="mini"
              type="primary"
              icon="el-icon-edit-outline"
              @click="openEditDialog(scope.row.id)"
              >编辑</el-button
            >
            <el-button
              v-hasPermission="'questionBankGoods:delete'"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="del(scope.row.id)"
              >删除</el-button
            >
            <!-- 生成激活码按钮 -->
            <el-button
              v-hasPermission="'activationCode:generate'"
              size="mini"
              type="info"
              icon="el-icon-key"
              @click="showGenerateCodeDialog(scope.row)"
              >生成激活码</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        style="margin-top: 10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryMap.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 激活码生成弹窗 -->
    <el-dialog
      title="生成商品激活码"
      :visible.sync="generateCodeDialogVisible"
      width="500px"
      :before-close="closeGenerateCodeDialog"
    >
      <!-- 第一步：输入生成数量 -->
      <div v-if="generateStep === 1">
        <el-form :model="generateForm" ref="generateFormRef" label-width="80px">
          <el-form-item label="商品名称">
            <el-input v-model="generateForm.goodsTitle" disabled></el-input>
          </el-form-item>
          <el-form-item label="生成数量" prop="count">
            <el-input
              type="number"
              v-model="generateForm.count"
              placeholder="请输入生成的激活码数量（1-100）"
              min="1"
              max="100"
              @input="
                generateForm.count = Math.max(
                  1,
                  Math.min(100, generateForm.count || 1)
                )
              "
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 第二步：显示生成结果 -->
      <div v-if="generateStep === 2">
        <div class="code-result-header">
          <span>生成成功！共 {{ generatedCodes.length }} 个激活码</span>
          <el-button
            type="text"
            icon="el-icon-copy"
            @click="copyAllCodes"
            class="copy-all-btn"
            >批量复制所有</el-button
          >
        </div>
        <el-table
          :data="generatedCodes"
          border
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column
            label="激活码"
            prop="code"
            width="300"
          ></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-copy"
                @click="copySingleCode(scope.row.code)"
                >复制</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 弹窗底部按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeGenerateCodeDialog">取消</el-button>
        <el-button
          type="primary"
          @click="generateCode"
          v-if="generateStep === 1"
          :loading="generateLoading"
          >生成</el-button
        >
        <el-button
          type="primary"
          @click="closeGenerateCodeDialog"
          v-if="generateStep === 2"
          >确认</el-button
        >
      </span>
    </el-dialog>

    <!-- 添加题库商品弹窗 -->
    <el-dialog
  title="添加题库商品"
  :visible.sync="addDialogVisible"
  width="60%"
  append-to-body
>
      <el-form
        :model="addForm"
        ref="addFormRef"
        label-width="100px"
        :rules="formRules"
      >
        <el-form-item label="商品标题" prop="title">
          <el-input
            v-model="addForm.title"
            placeholder="请输入商品标题（最长255字符）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品副标题" prop="subtitle">
          <el-input
            v-model="addForm.subtitle"
            placeholder="请输入商品副标题（最长500字符）"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面图URL" prop="coverImage">
          <el-input
            v-model="addForm.coverImage"
            placeholder="请输入封面图的URL地址（最长500字符）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品图片URL" prop="images">
          <el-input
            v-model="addForm.images"
            placeholder="请输入商品图片URL，多个地址用英文逗号分隔"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品原价" prop="originalPrice">
          <el-input
            type="number"
            step="0.01"
            min="0.01"
            v-model="addForm.originalPrice"
            placeholder="请输入商品原价（元）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品折扣价" prop="discountPrice">
          <el-input
            type="number"
            step="0.01"
            min="0.01"
            v-model="addForm.discountPrice"
            placeholder="请输入商品折扣价（元）"
          ></el-input>
        </el-form-item>
        <el-form-item label="实际售价" prop="sellingPrice">
          <el-input
            type="number"
            step="0.01"
            min="0.01"
            v-model="addForm.sellingPrice"
            placeholder="请输入商品实际售价（元）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品类型" prop="type">
          <el-select v-model="addForm.type" placeholder="请选择商品类型">
            <el-option label="单招" value="单招"></el-option>
            <el-option label="专升本" value="专升本"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品标签" prop="tags">
          <el-input
            v-model="addForm.tags"
            placeholder="请输入商品标签，多个标签用英文逗号分隔（最长500字符）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品状态" prop="status">
          <el-select v-model="addForm.status" placeholder="请选择商品状态">
            <el-option label="上架" value="上架"></el-option>
            <el-option label="下架" value="下架"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有效期（天）" prop="totalDuration">
          <el-input
            type="number"
            min="0"
            v-model="addForm.totalDuration"
            placeholder="请输入有效期天数，0表示永久有效"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序权重" prop="sort">
          <el-input
            type="number"
            min="0"
            v-model="addForm.sort"
            placeholder="请输入排序权重，数值越大排序越靠前"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品详情" prop="details">
          <el-input
            type="textarea"
            :rows="10"
            v-model="addForm.details"
            placeholder="请输入商品详情（支持HTML格式，最长65535字符）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="closeAddDialog">取消</el-button>
          <el-button type="primary" @click="submitAddForm" :loading="btnLoading"
            >确定</el-button
          >
        </div>
    </el-dialog>

    <!-- 编辑题库商品弹窗 -->
    <!-- 编辑题库商品弹窗 -->
    <el-dialog
      title="修改题库商品"
      :visible.sync="editDialogVisible"
      width="60%"
      append-to-body
    >
      <!-- 表单区域 -->
      <el-form
        :model="editForm"
        ref="editFormRef"
        label-width="100px"
        :rules="formRules"
      >
        <!-- 所有表单项（保持不变） -->
        <el-form-item label="商品标题" prop="title">
          <el-input
            v-model="editForm.title"
            placeholder="请输入商品标题（最长255字符）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品副标题" prop="subtitle">
          <el-input
            v-model="editForm.subtitle"
            placeholder="请输入商品副标题（最长500字符）"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面图URL" prop="coverImage">
          <el-input
            v-model="editForm.coverImage"
            placeholder="请输入封面图的URL地址（最长500字符）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品图片URL" prop="images">
          <el-input
            v-model="editForm.images"
            placeholder="请输入商品图片URL，多个地址用英文逗号分隔"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品原价" prop="originalPrice">
          <el-input
            type="number"
            step="0.01"
            min="0.01"
            v-model="editForm.originalPrice"
            placeholder="请输入商品原价（元）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品折扣价" prop="discountPrice">
          <el-input
            type="number"
            step="0.01"
            min="0.01"
            v-model="editForm.discountPrice"
            placeholder="请输入商品折扣价（元）"
          ></el-input>
        </el-form-item>
        <el-form-item label="实际售价" prop="sellingPrice">
          <el-input
            type="number"
            step="0.01"
            min="0.01"
            v-model="editForm.sellingPrice"
            placeholder="请输入商品实际售价（元）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品类型" prop="type">
          <el-select v-model="editForm.type" placeholder="请选择商品类型">
            <el-option label="单招" value="单招"></el-option>
            <el-option label="专升本" value="专升本"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品标签" prop="tags">
          <el-input
            v-model="editForm.tags"
            placeholder="请输入商品标签，多个标签用英文逗号分隔（最长500字符）"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品状态" prop="status">
          <el-select v-model="editForm.status" placeholder="请选择商品状态">
            <el-option label="上架" value="上架"></el-option>
            <el-option label="下架" value="下架"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有效期（天）" prop="totalDuration">
          <el-input
            type="number"
            min="0"
            v-model="editForm.totalDuration"
            placeholder="请输入有效期天数，0表示永久有效"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序权重" prop="sort">
          <el-input
            type="number"
            min="0"
            v-model="editForm.sort"
            placeholder="请输入排序权重，数值越大排序越靠前"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品详情" prop="details">
          <el-input
            type="textarea"
            :rows="10"
            v-model="editForm.details"
            placeholder="请输入商品详情（支持HTML格式，最长65535字符）"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 底部按钮区域：移到el-form外部，作为el-dialog的直接子元素，使用template插槽 -->
      <template slot="footer" class="dialog-footer">
        <el-button @click="closeEditDialog">取消</el-button>
        <el-button type="primary" @click="submitEditForm" :loading="btnLoading"
          >确定</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "QuestionBankGoods",
  data() {
    // 价格校验：折扣价 ≤ 原价
    const checkDiscountPrice = (rule, value, callback) => {
      const form = this.addDialogVisible ? this.addForm : this.editForm;
      const originalPrice = Number(form.originalPrice) || 0;
      if (!value) {
        callback(new Error("折扣价不能为空"));
      } else if (value > originalPrice) {
        callback(new Error("折扣价不能大于原价"));
      } else {
        callback();
      }
    };

    // 实际售价校验：实际售价 ≤ 折扣价
    const checkSellingPrice = (rule, value, callback) => {
      const form = this.addDialogVisible ? this.addForm : this.editForm;
      const discountPrice = Number(form.discountPrice) || 0;
      if (!value) {
        callback(new Error("实际售价不能为空"));
      } else if (value > discountPrice) {
        callback(new Error("实际售价不能大于折扣价"));
      } else {
        callback();
      }
    };

    return {
      // 加载状态
      loading: false,
      btnLoading: false,
      // 分页和查询条件
      queryMap: {
        pageNum: 1,
        pageSize: 20,
        title: "",
        type: "",
        status: "",
        tags: "",
        sortField: "",
        sortOrder: "",
      },
      // 商品列表数据
      goodsList: [],
      total: 0,
      // 新增弹窗相关
      addDialogVisible: false,
      addForm: {
        title: "",
        subtitle: "",
        coverImage: "",
        images: "",
        originalPrice: "",
        discountPrice: "",
        sellingPrice: "",
        type: "",
        tags: "",
        status: "上架",
        totalDuration: 0,
        details: "",
        sort: 0,
      },
      // 编辑弹窗相关
      editDialogVisible: false,
      editForm: {},
      editId: null, // 编辑的商品ID
      // 表单验证规则（新增/编辑共用）
      formRules: {
        title: [
          { required: true, message: "请输入商品标题", trigger: "blur" },
          {
            min: 1,
            max: 255,
            message: "标题长度不能超过255个字符",
            trigger: "blur",
          },
        ],
        subtitle: [
          { max: 500, message: "副标题长度不能超过500个字符", trigger: "blur" },
        ],
        coverImage: [
          { required: true, message: "请输入封面图URL", trigger: "blur" },
          {
            max: 500,
            message: "封面图URL长度不能超过500个字符",
            trigger: "blur",
          },
        ],
        images: [
          {
            max: 1000,
            message: "商品图片URL长度不能超过1000个字符",
            trigger: "blur",
          },
        ],
        type: [{ required: true, message: "请选择商品类型", trigger: "blur" }],
        status: [
          { required: true, message: "请选择商品状态", trigger: "blur" },
        ],
        tags: [
          { max: 500, message: "标签长度不能超过500个字符", trigger: "blur" },
        ],
        details: [{ max: 65535, message: "详情内容过长", trigger: "blur" }],
      },
      // 激活码生成相关
      generateCodeDialogVisible: false,
      generateStep: 1,
      generateLoading: false,
      generateForm: {
        goodsId: "",
        goodsTitle: "",
        count: 1,
      },
      generatedCodes: [],
    };
  },
  created() {
    // 初始化加载商品列表
    this.getGoodsList();
  },
  methods: {
    // ========== 商品列表相关 ==========
    /**
     * 获取商品列表（分页+查询）
     */
    async getGoodsList() {
      this.loading = true;
      try {
        // 调用后端列表接口：GET /questionBankGoods/list
        const { data: res } = await this.$http.get("/questionBankGoods/list", {
          params: {
            pageNum: this.queryMap.pageNum,
            pageSize: this.queryMap.pageSize,
            ...this.queryMap, // 传递查询条件（title、type、status等）
          },
        });
        if (res.code === 200) {
          this.goodsList = res.data.rows;
          this.total = res.data.total;
        } else {
          this.$message.error("获取商品列表失败：" + res.msg);
        }
      } catch (error) {
        this.$message.error("获取商品列表异常：" + error.message);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 搜索商品（重置页码为1）
     */
    searchGoods() {
      this.queryMap.pageNum = 1;
      this.getGoodsList();
    },

    /**
     * 重置查询条件
     */
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 20,
        title: "",
        type: "",
        status: "",
        tags: "",
        sortField: "",
        sortOrder: "",
      };
      this.searchGoods();
    },

    /**
     * 分页大小改变
     */
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getGoodsList();
    },

    /**
     * 当前页改变
     */
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getGoodsList();
    },

    // ========== 新增商品相关 ==========
    /**
     * 打开新增弹窗
     */
    openAddDialog() {
      // 重置新增表单
      this.addForm = {
        title: "",
        subtitle: "",
        coverImage: "",
        images: "",
        originalPrice: "",
        discountPrice: "",
        sellingPrice: "",
        type: "",
        tags: "",
        status: "上架",
        totalDuration: 0,
        details: "",
        sort: 0,
      };
      this.addDialogVisible = true;
      // 重置表单验证
      this.$nextTick(() => {
        this.$refs.addFormRef.clearValidate();
      });
    },

    /**
     * 关闭新增弹窗
     */
    closeAddDialog() {
      this.addDialogVisible = false;
    },

    /**
     * 提交新增表单
     */
    async submitAddForm() {
      try {
        // 表单验证
        await this.$refs.addFormRef.validate();
        this.btnLoading = true;

        // 构造提交参数（转换数值类型）
        const submitData = {
          ...this.addForm,
          originalPrice: Number(this.addForm.originalPrice),
          discountPrice: Number(this.addForm.discountPrice),
          sellingPrice: Number(this.addForm.sellingPrice),
          totalDuration: Number(this.addForm.totalDuration),
          sort: Number(this.addForm.sort),
        };

        // 调用后端新增接口：POST /questionBankGoods/add
        const { data: res } = await this.$http.post(
          "/questionBankGoods/add",
          submitData
        );
        if (res.code === 200) {
          this.$message.success("商品新增成功！");
          this.closeAddDialog();
          this.getGoodsList(); // 刷新列表
        } else {
          this.$message.error("商品新增失败：" + res.msg);
        }
      } catch (error) {
        // 表单验证失败时，error为验证信息，无需处理
        if (error.name !== "ValidationError") {
          this.$message.error("商品新增异常：" + error.message);
        }
      } finally {
        this.btnLoading = false;
      }
    },

    // ========== 编辑商品相关 ==========
    /**
     * 打开编辑弹窗（根据ID获取详情）
     */
    async openEditDialog(id) {
      this.editId = id; // 保存编辑的商品ID
      this.loading = true;
      try {
        // 调用后端详情接口：GET /questionBankGoods/edit/{id}
        const { data: res } = await this.$http.get(
          `/questionBankGoods/edit/${id}`
        );
        if (res.code === 200) {
          // 回显数据（转换数值类型为字符串，避免输入框显示异常）
          this.editForm = {
            ...res.data,
            originalPrice: res.data.originalPrice, // 后端返回的是数字/字符串，直接绑定
            discountPrice: res.data.discountPrice,
            sellingPrice: res.data.sellingPrice,
            totalDuration: res.data.totalDuration,
            sort: res.data.sort,
          };
          this.editDialogVisible = true;
          // 重置表单验证
          this.$nextTick(() => {
            this.$refs.editFormRef.clearValidate();
          });
        } else {
          this.$message.error("获取商品详情失败：" + res.msg);
        }
      } catch (error) {
        this.$message.error("获取商品详情异常：" + error.message);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 关闭编辑弹窗
     */
    closeEditDialog() {
      this.editDialogVisible = false;
      this.editId = null;
    },

    /**
     * 提交编辑表单
     */
    async submitEditForm() {
      if (!this.editId) {
        this.$message.error("未选择编辑的商品！");
        return;
      }

      try {
        // 表单验证
        await this.$refs.editFormRef.validate();
        this.btnLoading = true;

        // 构造提交参数（转换数值类型）
        const submitData = {
          ...this.editForm,
          originalPrice: Number(this.editForm.originalPrice),
          discountPrice: Number(this.editForm.discountPrice),
          sellingPrice: Number(this.editForm.sellingPrice),
          totalDuration: Number(this.editForm.totalDuration),
          sort: Number(this.editForm.sort),
        };

        // 调用后端更新接口：PUT /questionBankGoods/update/{id}
        const { data: res } = await this.$http.put(
          `/questionBankGoods/update/${this.editId}`,
          submitData
        );
        if (res.code === 200) {
          this.$message.success("商品编辑成功！");
          this.closeEditDialog();
          this.getGoodsList(); // 刷新列表
        } else {
          this.$message.error("商品编辑失败：" + res.msg);
        }
      } catch (error) {
        // 表单验证失败时，error为验证信息，无需处理
        if (error.name !== "ValidationError") {
          this.$message.error("商品编辑异常：" + error.message);
        }
      } finally {
        this.btnLoading = false;
      }
    },

    // ========== 删除商品相关 ==========
    /**
     * 删除商品
     */
    async del(id) {
      try {
        const confirmRes = await this.$confirm(
          "此操作将永久删除该商品，是否继续？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        if (confirmRes === "confirm") {
          // 调用后端删除接口：DELETE /questionBankGoods/delete/{id}
          const { data: res } = await this.$http.delete(
            `/questionBankGoods/delete/${id}`
          );
          if (res.code === 200) {
            this.$message.success("商品删除成功！");
            this.getGoodsList(); // 刷新列表
          } else {
            this.$message.error("商品删除失败：" + res.msg);
          }
        }
      } catch (error) {
        this.$message.info("已取消删除");
      }
    },

    // ========== 导出Excel相关 ==========
    /**
     * 导出Excel
     */
    downExcel() {
      axios
        .post("/questionBankGoods/excel", this.queryMap, {
          responseType: "blob", // 必须指定响应类型为blob
        })
        .then((res) => {
          if (res.headers["content-type"] === "application/json") {
            // 处理后端返回的错误信息
            const reader = new FileReader();
            reader.readAsText(res.data);
            reader.onload = () => {
              const errorData = JSON.parse(reader.result);
              this.$message.error(
                "导出失败：" + (errorData.msg || "无导出权限")
              );
            };
            return;
          }

          // 生成Excel文件并下载
          const data = res.data;
          const url = window.URL.createObjectURL(new Blob([data]));
          const a = document.createElement("a");
          a.href = url;
          a.download = "题库商品列表.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
          this.$message.success("导出成功！");
        })
        .catch(() => {
          this.$message.error("导出失败，请重试！");
        });
    },

    // ========== 激活码生成相关 ==========
    /**
     * 显示激活码生成弹窗
     */
    showGenerateCodeDialog(goods) {
      this.generateForm = {
        goodsId: goods.id,
        goodsTitle: goods.title,
        count: 1,
      };
      this.generateStep = 1;
      this.generatedCodes = [];
      this.generateCodeDialogVisible = true;
    },

    /**
     * 关闭激活码生成弹窗
     */
    closeGenerateCodeDialog() {
      this.generateCodeDialogVisible = false;
    },

    /**
     * 生成激活码（需补充后端接口）
     */
    async generateCode() {
      try {
        await this.$refs.generateFormRef.validate();
        this.generateLoading = true;

        // 调用激活码生成接口（需后端实现：POST /activationCode/generate）
        const { data: res } = await this.$http.post(
          "/activationCode/generate",
          {
            goodsId: this.generateForm.goodsId,
            count: this.generateForm.count,
          }
        );

        if (res.code === 200) {
          this.generatedCodes = res.data.map((code) => ({ code }));
          this.generateStep = 2;
        } else {
          this.$message.error("生成激活码失败：" + res.msg);
        }
      } catch (error) {
        this.$message.error("生成激活码异常：" + error.message);
      } finally {
        this.generateLoading = false;
      }
    },

    /**
     * 复制单个激活码
     */
    copySingleCode(code) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          this.$message.success("复制成功！");
        })
        .catch(() => {
          this.$message.error("复制失败，请手动复制！");
        });
    },

    /**
     * 批量复制所有激活码
     */
    copyAllCodes() {
      const allCodes = this.generatedCodes.map((item) => item.code).join("\n");
      navigator.clipboard
        .writeText(allCodes)
        .then(() => {
          this.$message.success("所有激活码已批量复制！");
        })
        .catch(() => {
          this.$message.error("批量复制失败，请手动复制！");
        });
    },
  },
};
</script>

<style scoped>
/* 激活码结果列表头部样式 */
.code-result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.copy-all-btn {
  color: #409eff;
  padding: 0;
}

.copy-all-btn:hover {
  color: #66b1ff;
}

/* 表单项间距 */
.el-form-item {
  margin-bottom: 20px;
}
</style>
